import { IconProps } from 'blaze-ui/icons/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { PlatformIcons } from './constants'

interface PlatformIconProps extends IconProps {
  provider: ExternalIntegrationEnum
}

export const PlatformIcon = ({ provider, ...iconProps }: PlatformIconProps) => {
  const Component = PlatformIcons[provider]
  return <Component {...iconProps} />
}
